/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Properties_TitleInputs */

const cs_properties_title = /** @type {(inputs: Properties_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitosti`)
};

const en_properties_title = /** @type {(inputs: Properties_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties`)
};

/**
* | output |
* | --- |
* | "Properties" |
*
* @param {Properties_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const properties_title = /** @type {((inputs?: Properties_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Properties_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_properties_title(inputs)
	return cs_properties_title(inputs)
});